export const TEXTS_CONFIG = {
  PASSWORD_FIELD_EMPTY: 'Введите пароль',
  EMAIL_FIELD_EMPTY: 'Введите email',
  EMAIL_FIELD_VALID: 'Введите корректный email',
};
